export default "__VITE_ASSET__CeR_PdDC__"